var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins } from 'vue-property-decorator';
// Entities
import { Company } from 'packages/company/entities/Company';
import { Job } from 'packages/jobs/entities/Job';
import { BrandingSettings } from 'packages/company/entities/BrandingSettings';
import { LandingPage } from 'packages/landing_pages/LandingPage';
// Components
import FullScreenLoader from 'common/components/ui/loaders/FullScreenLoader.vue';
import Navigation from '../components/Navigation.vue';
import Icon from 'common/UIToolKit/Icon.vue';
import DeltaRenderer from 'packages/core/DeltaRenderer';
import PageNotFound from 'ui/v1/pages/PageNotFound.vue';
import { Action, Mutation, namespace, State } from 'vuex-class';
import { JobList } from 'packages/job_lists/JobList';
import { PlaceholderHelper } from 'packages/email/PlaceholderHelper';
import Meta from 'common/mixins/Meta.mixin';
var jobListsModule = namespace('jobLists');
var landingPagesModule = namespace('landingPages');
var publicCompanyModule = namespace('publicCompany');
var LandingPageView = /** @class */ (function (_super) {
    __extends(LandingPageView, _super);
    function LandingPageView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LandingPageView.prototype, "pageTitle", {
        get: function () {
            if (this.loading) {
                return '…';
            }
            if (this.landingPageNotFound || !this.landingPage || !this.company) {
                return this.$t('pages.not_found.content');
            }
            if (this.jobList) {
                return PlaceholderHelper.convertPlaceholdersToValues(this.jobList.title, new Map([['job.name', this.job.name], ['dash', '-']]));
            }
            return (this.landingPageNotFound || !this.landingPage || !this.company)
                ? this.$t('pages.not_found.content').toString()
                : this.job.name + " - " + this.company.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LandingPageView.prototype, "logo", {
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return ((_c = (_b = (_a = this.landingPage) === null || _a === void 0 ? void 0 : _a.appearance) === null || _b === void 0 ? void 0 : _b.logo) === null || _c === void 0 ? void 0 : _c.url)
                || ((_f = (_e = (_d = this.jobList) === null || _d === void 0 ? void 0 : _d.appearance) === null || _e === void 0 ? void 0 : _e.logo) === null || _f === void 0 ? void 0 : _f.url)
                || ((_h = (_g = this.branding) === null || _g === void 0 ? void 0 : _g.logo) === null || _h === void 0 ? void 0 : _h.url)
                || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LandingPageView.prototype, "heroImage", {
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return ((_c = (_b = (_a = this.landingPage) === null || _a === void 0 ? void 0 : _a.appearance) === null || _b === void 0 ? void 0 : _b.heroImage) === null || _c === void 0 ? void 0 : _c.url)
                || ((_f = (_e = (_d = this.jobList) === null || _d === void 0 ? void 0 : _d.appearance) === null || _e === void 0 ? void 0 : _e.heroImage) === null || _f === void 0 ? void 0 : _f.url)
                || ((_h = (_g = this.branding) === null || _g === void 0 ? void 0 : _g.heroImage) === null || _h === void 0 ? void 0 : _h.url)
                || null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LandingPageView.prototype, "job", {
        get: function () {
            if (this.landingPage && this.landingPage.job) {
                return this.landingPage.job;
            }
            return new Job();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LandingPageView.prototype, "landingPageContent", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.landingPage) === null || _a === void 0 ? void 0 : _a.content) !== null && _b !== void 0 ? _b : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LandingPageView.prototype, "landingPageHtmlContent", {
        get: function () {
            if (this.landingPageContent) {
                var renderer = new DeltaRenderer(this.landingPageContent);
                return renderer.getHtml();
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LandingPageView.prototype, "accessToken", {
        get: function () {
            return this.$route.query.accessToken;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LandingPageView.prototype, "jobListQuery", {
        get: function () {
            return !this.accessToken ? {} : {
                accessToken: this.accessToken,
            };
        },
        enumerable: false,
        configurable: true
    });
    LandingPageView.prototype.created = function () {
        var stringId = this.$route.params.listId;
        if (stringId && !this.jobList) {
            this.getJobListFromIdString({ stringId: stringId, accessToken: this.accessToken });
        }
    };
    LandingPageView.prototype.mounted = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var stringIdentifier;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        stringIdentifier = this.$route.params.stringIdentifier;
                        return [4 /*yield*/, this.getLandingPage({ stringIdentifier: stringIdentifier, accessToken: this.accessToken })];
                    case 1:
                        _b.sent();
                        if (this.landingPageNotFound) {
                            return [2 /*return*/];
                        }
                        if (this.$route.query.locale || this.landingPage.locale) {
                            this.$app.languageService.setLanguage((_a = this.$route.query.locale) !== null && _a !== void 0 ? _a : this.landingPage.locale);
                        }
                        return [4 /*yield*/, this.getCompany(this.landingPage.companyId)];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.getBrandingSettings(this.landingPage.companyId)];
                    case 3:
                        _b.sent();
                        this.setAppearance(this.jobList ? this.jobList.appearance : this.landingPage.appearance);
                        this.setMetaData(this.jobList);
                        return [2 /*return*/];
                }
            });
        });
    };
    LandingPageView.prototype.setMetaData = function (jobList) {
        var _a, _b, _c;
        this.setCanonicalLink((_a = this.landingPage) === null || _a === void 0 ? void 0 : _a.generateLink(this.job.isHidden && this.accessToken));
        var sharing = jobList === null || jobList === void 0 ? void 0 : jobList.sharingSettings;
        if (!sharing) {
            return;
        }
        if (sharing.cleanTitle && ((_c = (_b = this.landingPage) === null || _b === void 0 ? void 0 : _b.job) === null || _c === void 0 ? void 0 : _c.name)) {
            this.setMetaTitles(PlaceholderHelper.convertPlaceholdersToValues(sharing.cleanTitle, new Map([['job.name', this.job.name], ['dash', '-']])));
        }
        else {
            this.setMetaTitles(this.job.name + " - " + this.company.name);
        }
        if (sharing.description) {
            this.setMetaDescriptions(sharing.description);
        }
        if (sharing.image) {
            this.setMetaImage(sharing.image.uri);
        }
        this.setTwitterCard(!!sharing.image);
    };
    var _a, _b, _c, _d;
    __decorate([
        publicCompanyModule.State,
        __metadata("design:type", typeof (_a = typeof Company !== "undefined" && Company) === "function" ? _a : Object)
    ], LandingPageView.prototype, "company", void 0);
    __decorate([
        State,
        __metadata("design:type", typeof (_b = typeof BrandingSettings !== "undefined" && BrandingSettings) === "function" ? _b : Object)
    ], LandingPageView.prototype, "branding", void 0);
    __decorate([
        publicCompanyModule.Action,
        __metadata("design:type", Function)
    ], LandingPageView.prototype, "getCompany", void 0);
    __decorate([
        Action,
        __metadata("design:type", Function)
    ], LandingPageView.prototype, "getBrandingSettings", void 0);
    __decorate([
        landingPagesModule.State,
        __metadata("design:type", typeof (_c = typeof LandingPage !== "undefined" && LandingPage) === "function" ? _c : Object)
    ], LandingPageView.prototype, "landingPage", void 0);
    __decorate([
        landingPagesModule.State('loadingLandingPage'),
        __metadata("design:type", Boolean)
    ], LandingPageView.prototype, "loading", void 0);
    __decorate([
        landingPagesModule.State,
        __metadata("design:type", Boolean)
    ], LandingPageView.prototype, "landingPageNotFound", void 0);
    __decorate([
        landingPagesModule.Action,
        __metadata("design:type", Function)
    ], LandingPageView.prototype, "getLandingPage", void 0);
    __decorate([
        jobListsModule.State,
        __metadata("design:type", typeof (_d = typeof JobList !== "undefined" && JobList) === "function" ? _d : Object)
    ], LandingPageView.prototype, "jobList", void 0);
    __decorate([
        jobListsModule.Getter,
        __metadata("design:type", String)
    ], LandingPageView.prototype, "favicon", void 0);
    __decorate([
        jobListsModule.Action('getListForStringId'),
        __metadata("design:type", Function)
    ], LandingPageView.prototype, "getJobListFromIdString", void 0);
    __decorate([
        Mutation('setAppearance'),
        __metadata("design:type", Object)
    ], LandingPageView.prototype, "setAppearance", void 0);
    LandingPageView = __decorate([
        Component({
            components: {
                PageNotFound: PageNotFound,
                Icon: Icon,
                JobListNavigation: Navigation,
                FullScreenLoader: FullScreenLoader,
            },
            metaInfo: function () {
                var _a;
                // vmid is specified for favicon to override default favicon set in PublicApp
                return {
                    title: this.pageTitle,
                    link: [
                        { vmid: 'favicon', rel: 'icon', href: (_a = this.branding.favicon) === null || _a === void 0 ? void 0 : _a.uri },
                    ],
                };
            },
        })
    ], LandingPageView);
    return LandingPageView;
}(Mixins(Meta)));
export default LandingPageView;
